import Core from './Core';
import Hybrid from './Hybrid';

export default {
  Core,
  Hybrid,
};
